import { ComponentProps, useCallback, useMemo } from "react"
import { InfoBlock } from "../../../components/infoBlock/InfoBlock"
import { InfoBlockWrap } from "../../../components/infoBlock/InfoBlockWrap"
import { getErrors } from "../../../fetch/errors"
import { toast } from "react-toastify"
import { finishTask } from "../../../fetch/tasks"
import { Task, TaskStatus } from "../../../../types"
import { useFetchHook } from "../../../lib/hooks/fetchHook"
import { createColumns } from "./columns"
import { DataTable } from "@/components/dataTable/DataTable"

export const AdminErrors = () => {
  const { data, reload } = useFetchHook<
    { items: Task[]; info: ComponentProps<typeof InfoBlock>[] },
    Record<string, any>
  >(getErrors, { defaultValue: { items: [], info: [] } })

  const confirmTask = useCallback(
    async (
      e: React.MouseEvent<HTMLButtonElement>,
      id: number,
      status: TaskStatus
    ) => {
      e.preventDefault()
      e.stopPropagation()
      console.log({ status, id })
      await finishTask(id, {
        status:
          status === TaskStatus.Error
            ? TaskStatus.ErrorAck
            : TaskStatus.Approved,
      })

      toast("Uzdevums veiksmīgi apstiprināts!", { type: "success" })
      reload()
    },
    [reload]
  )

  const columns = useMemo(() => createColumns(confirmTask), [])
  return (
    <>
      <InfoBlockWrap>
        {data?.info.map((block, i) => (
          <InfoBlock {...block} key={i} />
        ))}
      </InfoBlockWrap>
      <DataTable
        columns={columns}
        data={data.items}
        searchFields={[
          "workerName",
          "projectName",
          "subProjectName",
          "operationName",
        ]}
      />
    </>
  )
}
